/****************************************************
 * Module Name:  login.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import * as React from "react";
import { Component } from "react";
import { Box, Button, Drawer } from "@mui/material";
import "bootstrap/dist/css/bootstrap.min.css";
import Constants from "../../utility/constants";
import Utility from "../../utility/utility";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import UserProxy from "./../../utility/proxy/manager/userProxy";
import { SignUp } from "../signup/signUp";
import CommonSnackbar from "../common/commonSnackBar";
import UtilityProxy from "../../utility/proxy/manager/utilityProxy";

export class Login extends Component {
  constructor(props) {
    super(props);

    this.state = {
      userName: "",
      password: "",
      passwordType: "password",
      inputEyetype: "password",
      showErrorDialog: false,
      errorMessage: "",
      variant: "",
      autoHide: false,
      title: "",
      openDrawer: false,

      drawerSnackbar: false,
      drawerSnackbarMessage: "",
      drawerSnackbarVariant: "",

      loginValidationError: "",
      passwordValidationError: "",
    };

    UtilityProxy.pingServer(response => {
      if (!response) {
        this.setState({
          showErrorDialog: true,
          errorMessage: "Server not reachable. Contact Support - info@pansuriyaimpex.com",
          variant: "error",
          autohide: Constants.SnackBarCloseTimer,
          title: "Error",
        });
      }
    })
  }

  handleKeyDown = (event) => {
    if (event.key === "Enter") this.submitClick(event);
  };

  typeHandle = (e) => {
    if (
      this.state.inputEyetype === "password" &&
      (e.type === "mousedown" || e.type === "mouseup")
    ) {
      this.setState({ inputEyetype: "text" });
    } else {
      this.setState({ inputEyetype: "password" });
    }
  };

  showSnackBarFromDrawer = (message, variant) => {
    this.setState({
      drawerSnackbar: true,
      drawerSnackbarMessage: message,
      drawerSnackbarVariant: variant,
    });
  }

  submitClick = (event) => {
    event.preventDefault();
    let validateUser = {
      username: this.state.userName,
      password: this.state.password,
    };

    UserProxy.Validate(validateUser, (response) => {
      if (response) {
        if (this.props.onSuccess) {
          //response.status is user token received from backend
          UserProxy.GetSingleUserByUserName(this.state.userName, response.status, (uResponse) => {
            //response.status is JWT token
            this.props.onSuccess(uResponse, response.status);
          });
        }
      } else {
        this.setState({
          showErrorDialog: true,
          errorMessage: "Invalid Username or Password entered",
          variant: "error",
          autohide: false,
          title: "Validation Failure",
        });
      }
    });
  };

  handleClose = () => {
    this.setState({
      showErrorDialog: false,
    });
  };

  resetClick = (event) => {
    this.setState({
      userName: "",
      password: "",
    });
  };

  setUserName = (event) => {
    this.setState({
      userName: event.target.value,
    });
  };

  setPassword = (event) => {
    this.setState({
      password: event.target.value,
    });
  };

  handleDrawerClose = () => {
    this.setState({ openDrawer: false })
  }


  handleForgotPassword = () => {
    if (this.state.userName.length !== 0) {
      UserProxy.ForgotPassword(this.state.userName, (response) => {
        this.setState({
          showErrorDialog: true,
          errorMessage:
            response.status === "Success"
              ? response.errorMessage
              : "Check the username and try again",
          variant: response.status.toLowerCase(),
          autoHide: response.status === "Success" ? true : false,
          title:
            response.status === "Success" ? "Success" : "Something Went Wrong",
        });
      });
    } else {
      this.setState({ loginValidationError: "Username Cannot be Empty" });
    }
  };

  render() {
    return (
      <div>
        {this.state.showErrorDialog ? (
          <CommonSnackbar
            show={true}
            message={this.state.errorMessage}
            variant={this.state.variant}
            autoHide={this.state.autoHide}
            handleClose={this.handleClose}
            title={this.state.title}
          />
        ) : (
          <Box />
        )}
        <div className="min-vh-100">
          {this.state.drawerSnackbar ?
            <CommonSnackbar
              show={true}
              message={this.state.drawerSnackbarMessage}
              variant={this.state.drawerSnackbarVariant}
              autoHide={Constants.SnackBarCloseTimer}
              handleClose={() => this.setState({ drawerSnackbar: false })}
              title={
                this.state.drawerSnackbarVariant === "success" ? "Success" : "Failed"
              }
            />
            :
            <div />
          }
          <div className="" />
          {/* auth-page content */}
          <div className="auth-page-content overflow-hidden">
            <div className="">
              <div className="row min-vh-100">
                <div className="col-lg-12">
                  <div className="overflow-hidden">
                    <div className="row g-0 min-vh-100">
                      <div className="col-lg-8 d-none d-md-block d-lg-block d-xl-block">
                      <div>
                          <video
                            autoPlay
                            loop
                            muted
                            playsInline
                            className="hero1-video"
                          >
                            <source
                              src={"/assets/videos/diamonds.mp4"}
                              type="video/mp4"
                            />
                            Your browser does not support the video tag.
                          </video>
                          <div className="hero1-overlay" />
                        </div>
                        <div className="p-lg-5 p-4 h-100">
                          <div className="position-relative h-100 d-flex flex-column">
                            <div className="mb-4" style={{zIndex:10}}>
                              <a href="/" className="d-block">
                                <img
                                  src="../pansuriyaMainLogo.png"
                                  alt=""
                                  height={60}
                                />
                              </a>
                            </div>
                            <div className="mt-auto" style={{zIndex:10}}>
                              <div className="mb-3">
                                <i className="ri-double-quotes-l display-4 text-success" />
                              </div>
                              <div
                                id="qoutescarouselIndicators"
                                className="carousel slide"
                                data-bs-ride="carousel"
                              >
                                <div className="carousel-indicators">
                                  <button
                                    type="button"
                                    data-bs-target="#qoutescarouselIndicators"
                                    data-bs-slide-to={0}
                                    className="active"
                                    aria-current="true"
                                    aria-label="Slide 1"
                                  />


                                </div>
                                <div className="carousel-inner text-center text-white-50 pb-5">
                                  <div className="carousel-item active">
                                  <p className="fs-15 fst-italic">
                                      {`We have more than ${new Date().getFullYear() -
                                        1972} years of experience in the field of rough and polished diamonds. Since 1972 we are dealing in diamonds manufacturing, importing and exporting. Before the year 2000, we used to deal in our business at the heart of diamond manufacturing city in India — yes, that is SURAT.`}
                                    </p>
                                  </div>


                                </div>
                              </div>
                              {/* end carousel */}
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* end col */}
                      <div className="col-lg-4" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                        <div className="p-lg-5 p-4">
                          <div>
                            <h5 className="text-primary">Welcome !</h5>
                            <p className="text-muted">
                              Sign in to continue to {Constants.COMPANY_NAME}.
                            </p>
                          </div>

                          <div className="mt-4">
                            <div className="mb-3">
                              <label htmlFor="username" className="form-label">
                                Username
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                id="username"
                                placeholder="Enter username"
                                onChange={(e) =>
                                  this.setState({
                                    loginValidationError: Utility.CheckIsPresent(
                                      e.target.value
                                    )
                                      ? ""
                                      : "Username Cannot be Empty",
                                    userName: e.target.value.trim(),
                                  })
                                }
                                value={this.state.userName}
                              />
                              <span style={{ color: 'red' }}>
                                {this.state.loginValidationError ? this.state.loginValidationError : null}
                              </span>
                            </div>

                            <div className="mb-3">
                              <label
                                className="form-label"
                                htmlFor="password-input">
                                Password
                              </label>
                              <div className="position-relative auth-pass-inputgroup mb-3">
                                <input
                                  type={this.state.inputEyetype}
                                  className="form-control pe-5 password-input"
                                  placeholder="Enter password"
                                  id="password-input"
                                  onChange={(e) =>
                                    this.setState({
                                      passwordValidationError: Utility.CheckIsPresent(
                                        e.target.value
                                      )
                                        ? ""
                                        : "Password Cannot be Empty",
                                      password: e.target.value,
                                    })
                                  }
                                  onKeyDown={(e) => {
                                    if (e.key === "Enter" && e.keyCode === 13) this.submitClick(e)
                                  }}
                                  value={this.state.password}
                                />
                                <button
                                  className="btn btn-link position-absolute end-0 top-0 text-decoration-none shadow-none text-muted password-addon"
                                  type="button"
                                  onMouseDown={(e) => this.typeHandle(e)}
                                  onMouseUp={(e) => this.typeHandle(e)}
                                  onMouseLeave={(e) => this.typeHandle(e)}
                                  id="password-addon"
                                >
                                  {this.state.inputEyetype === "password" ? (
                                    <VisibilityOffIcon />
                                  ) : (
                                    <VisibilityIcon />
                                  )}
                                </button>

                                <span style={{ color: 'red' }}>
                                  {this.state.passwordValidationError ? this.state.passwordValidationError : null}
                                </span>
                                <div className="float-end">
                                  <a
                                    href="#s"
                                    className="text-muted"
                                    onClick={() => this.handleForgotPassword()}
                                  >
                                    Forgot password?
                                  </a>
                                </div>
                              </div>
                            </div>


                            <div className="mt-4" style={{ justifyContent: 'center', display: 'flex', width: '100%' }}>
                              <button
                                className="btn btn-success w-50 m-1"
                                type="submit"
                                onClick={(e) => this.submitClick(e)}
                              >
                                Sign In
                              </button>
                              <button
                                className="btn btn-danger w-50 m-1"
                                type="submit"
                                onClick={() => this.resetClick()}
                              >
                                Reset
                              </button>
                            </div>
                          </div>
                          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: 20 }}>
                            Don't have an Account ?<Button onClick={() => this.setState({ openDrawer: true })}>Sign Up</Button>
                            <Drawer
                              anchor="right"
                              open={this.state.openDrawer}
                              onClose={() => this.handleDrawerClose()}>
                              <SignUp closeDrawer={this.handleDrawerClose} showSnackBar={(message, variant) => this.showSnackBarFromDrawer(message, variant)} />
                            </Drawer>
                          </div>
                        </div>
                      </div>
                      {/* end col */}
                    </div>
                    {/* end row */}
                  </div>
                  {/* end card */}
                </div>
                {/* end col */}
              </div>
              {/* end row */}
            </div>
            {/* end container */}
          </div>
          {/* end auth page content */}
        </div>
        {/* end auth-page-wrapper */}
      </div>

    );
  }
}

export default Login;
